export default {
  data: [
    {
      id: 1,
      desingName: "Diseño 1",
      articleId: 1,
      furnace: {
        temperature: 900,
        heating_ramp: 100,
        piece_temperrature: 35
      },
      quenching: {
        bath_type: "water",
        bath_temperature: 50,
        agitation_level: 2,
        hard_coat: 30
      },
      tempered: {
        temperature: 600,
        heating_ramp: 100,
        hardness_required: 700
      },
      date: "2020-02-10T13:52:39+01:00",
      recommendation: {
        furnace_time: 37800,
        quenching: 30,
        tempered_time: 23400
      }
    },
    {
      id: 2,
      desingName: "Diseño 2",
      articleId: 1,
      furnace: {
        temperature: 950,
        heating_ramp: 70,
        piece_temperrature: 35
      },
      quenching: {
        bath_type: "water",
        bath_temperature: 60,
        agitation_level: 3,
        hard_coat: 30
      },
      tempered: {
        temperature: 600,
        heating_ramp: 100,
        hardness_required: 700
      },
      date: "2020-02-10T18:52:39+01:00",
      recommendation: {
        furnace_time: 34200,
        quenching: 35,
        tempered_time: 21600
      }
    }
  ]
};
